export const displaymethodData = [
    { name: "Grouper par équipements", id: "equipments" },
    { name: "Liste des points de données", id: "points" }
]

export const equipmentcriticityData = [
    { name: "Non critique (données uniquement)", id: "1" },
    { name: "Moyenne (pilotage sans incidence directe)", id: "2" },
    { name: "Critique (pilotage, sonde pour pilotage critique)", id: "3" },
]

export const criticityData = [
    { name: "OK", id: "0" },
    { name: "Information", id: "1" },
    { name: "Avertissement", id: "2" },
    { name: "Critique", id: "3" },
]
export const closedData = [
    { name: "Non", id: "0" },
    { name: "Oui", id: "1" },
]

export const fieldprotocoleData = [
    { name: "Modbus RTU", id: "modbus" },
    { name: "Impulsion", id: "pulse" },
    { name: "LoRaWAN", id: "lorawan" },
    { name: "Modbus IP", id: "modbusip" },
    { name: "Hydrelis", id: "hydrelis" },
    { name: "BacNet", id: "bacnet" },
]

export const eosprotocoleData = [
    { name: "LoRaWAN", id: "lorawan" },
    { name: "Modbus Radio", id: "modbusradio" },
    { name: "Modbus RTU", id: "modbus" },
    { name: "Modbus IP", id: "modbusip" },
    { name: "Hydrelis", id: "hydrelis" },
    { name: "Fichier CSV", id: "csv" },
    { name: "BacNet", id: "bacnet" },
]

export const eosprotocoleDataSelect = [
    { name: "LoRaWAN", id: "lorawan" },
    { name: "Modbus RTU", id: "modbus" },
    { name: "Modbus IP", id: "modbusip" },
    { name: "BacNet", id: "bacnet" },
]

export const pointeosprotocoleDataSelect = [
    { name: "Serveur LoRaWAN AVOB", id: "avoblorawanserver" },
    { name: "LoRaWAN via AVOB Box", id: "avoblorawanbox" },
    { name: "Orange LoRaWAN", id: "orangelorawanserver" },
    { name: "Wiotys LoRaWAN", id: "wiotyslorawanserver" },
    { name: "Modbus RTU via AVOB Box", id: "modbus" },
    { name: "Modbus IP via AVOB Box", id: "modbusip" },
    { name: "BacNet via AVOB Box", id: "bacnet" },
]

export const pointliveDataSelect = [
    { name: "Standard", id: 0 },
    { name: "Live sans rétention", id: 1 },
    { name: "Live avec rétention", id: 2 },
]

export const stateData = [
    { name: "Lecture active", id: 0 },
    { name: "Pilotage actif", id: 1 },
    { name: "Inactif", id: 3 },
]

export const stateNotControlableData = [
    { name: "Lecture active", id: 0 },
    { name: "Inactif", id: 3 },
]

export const controlmodeData = [
    { name: "Valeur constante", id: 0 },
    { name: "Planning et formule", id: 1 },
    { name: "Script", id: 2 },
]

export const controlmodeDataWithoutscript = [
    { name: "Valeur constante", id: 0 },
    { name: "Planning et formule", id: 1 },
]

export const definitionData = [
    { name: "Desktop Computer", id: 1 },
    { name: "Laptop Computer", id: 2 },
    { name: "Unknown", id: 3 },
    { name: "Sensor", id: 4 },
    { name: "Chaudière", id: 5 },
    { name: "Compteur chaleur", id: 6 },
    { name: "Compteur eau", id: 7 },
    { name: "Compteur electricité", id: 8 },
    { name: "Compteur froid", id: 9 },
    { name: "Compteur gaz", id: 10 },
    { name: "Centrale de traitement d'air", id: 11 },
    { name: "Echangeur de chaleur", id: 12 },
    { name: "Eclairage", id: 13 },
    { name: "Refroidisseur", id: 14 },
    { name: "Tour de refroidissement", id: 15 },
    { name: "Ventilo-Convecteurs", id: 16 },
    { name: "Schedule", id: 17 },
    { name: "Pompes à chaleur", id: 18 },
    { name: "Monosplit", id: 19 },
    { name: "Capteurs", id: 20 },
    { name: "Cassette 4 voies", id: 21 },
    { name: "Gainable compact DRV", id: 22 },
    { name: "Mural DRV", id: 23 },
    { name: "Console DRV", id: 24 },
    { name: "Général", id: 25 },
    { name: "VRV", id: 26 },
    { name: "Etat", id: 27 },
    { name: "Thermofrigopompe", id: 28 },
    { name: "Point de consigne hiver", id: 29 },
    { name: "Point de consigne été", id: 30 },
    { name: "Point de consigne récupération active", id: 31 },
    { name: "Point de consigne installation en cours", id: 32 },
    { name: "Cassette", id: 33 },
    { name: "Mode de fonctionnement", id: 34 },
    { name: "Energie", id: 35 },
    { name: "Actionneur", id: 36 },
    { name: "Réseau hydraulique", id: 37 },
    { name: "Compteurs d'énergie", id: 38 },
    { name: "Compteur electricité divisionnaire", id: 39 },
    { name: "Solar", id: 40 },
    { name: "House", id: 41 },
    { name: "Battery", id: 42 },
    { name: "Outdoor", id: 43 },
    { name: "Nest Thermostat", id: 44 },
    { name: "Electricity", id: 45 },
    { name: "Sensors", id: 46 },
    { name: "Contactor", id: 47 },
    { name: "Saisie - Electricité", id: 48 },
    { name: "Saisie - Gaz Naturel", id: 49 },
    { name: "Saisie - Réseau de Chaleur", id: 50 },
    { name: "Saisie - Bois Déchiqueté", id: 51 },
    { name: "Saisie - Fioul", id: 52 },
    { name: "Saisie - Gaz Propane", id: 53 },
    { name: "Saisie - Eau", id: 54 },
    { name: "Saisie - Déchets", id: 55 },
    { name: "Import - Electricité", id: 56 },
    { name: "Equivalence", id: 57 },
    { name: "Saisie - Paramètres de simulation", id: 58 },
    { name: "Saisie - Paramètres du site", id: 59 },
    { name: "Import - Gaz", id: 60 },
    { name: "Import - Eau", id: 61 },
    { name: "rte", id: 62 },
    { name: "Import - Eau glacée", id: 63 },
    { name: "Import - Eau chaude", id: 64 },
    { name: "Nest Structure", id: 65 },
    { name: "External Weather", id: 66 },
    { name: "Objenious equipment", id: 67 },
    { name: "EnedisApi", id: 68 },
    { name: "Facture Electricité Calculée", id: 69 },
    { name: "GRDF", id: 70 },
    { name: "Ecran", id: 71 },
    { name: "Import - Fioul", id: 72 },
    { name: "Import - Bois", id: 73 },
    { name: "Import - Gaz Propane", id: 74 },
    { name: "Vanne thermostatique", id: 75 },
    { name: "Véhicule", id: 76 },
    { name: "VMC", id: 77 },
    { name: "Compteur de fréquentation", id: 78 },
    { name: "Convecteur", id: 79 },
    { name: "Electrovanne", id: 80 },
    { name: "Automate", id: 81 },
    { name: "BAMO BMG 72", id: 82 },
    { name: "Electrical Vehicle", id: 1000 },
];

export const hardwareData = [
    { name: "Non défini", id: -1 },
    { name: "Adeunis temp", id: 1 },
    { name: "Adeunis temp 2s", id: 2 },
    { name: "Compteur d'eau impulsion", id: 3 },
    { name: "Compteur de gaz impulsion", id: 4 },
    { name: "Elsys ERS Ambiance", id: 5 },
    { name: "Elsys ERS Ambiance CO2", id: 6 },
    { name: "Elsys ERS Lite", id: 7 },
    { name: "Elsys ERS CO2 Lite", id: 8 },
    { name: "Ewattch squid", id: 9 },
    { name: "MClimate 16A Dry Switch", id: 10 },
    { name: "MClimate Vicki", id: 11 },
    { name: "Metz Connect MRAOP4", id: 12 },
    { name: "Metz Connect MRD04", id: 13 },
    { name: "Elsys ETH D10", id: 14 },
    { name: "NKE Température extérieure", id: 15 },
    { name: "LETTEL MAP4-34RJ", id: 16 },
    { name: "Intesis IR", id: 17 },
    { name: "Intesis INDOOR - DAIKIN", id: 18 },
    { name: "Intesis INDOOR - MITSUBISHI", id: 19 },
    { name: "Intesis INDOOR - TOSHIBA", id: 20 },
    { name: "LETTEL MCT1-140", id: 21 },
    { name: "Enginko MCF", id: 22 },
    { name: "LETTEL MCX4-34V", id: 23 },
    { name: "Schneider IEM3155", id: 24 },
    { name: "Ixel TicBus", id: 25 },
    { name: "Enginko Prise connectée", id: 26 },
    { name: "ETT CH77RE", id: 27 },
    { name: "Atlantic DuoTech", id: 28 },
    { name: "Schneider IEM3255", id: 29 },
    { name: "SAIA PCD", id: 30 },
    { name: "MClimate 16A Switch & Power", id: 31 },
    { name: "Le Grand 046 80", id: 32 },
    { name: "CTA France Air Wallplay", id: 33 },
    { name: "Intesis Panasonic Air to Water", id: 34 },
    { name: "Wattsense Bridge Small", id: 35 },
    { name: "Passerelle Dietriech GTW26 - AD325", id: 36 },
    { name: "UI Daikin via Intesis", id: 37 },
    { name: "UI Hitachi via Intesis", id: 38 },
    { name: "CTA CAD O INTEGRAL CORRIGO ETD2", id: 39 },
    { name: "CTA CAD O INTEGRAL EC 100 VLEXG", id: 40 },
    { name: "Socomec Countis E33", id: 41 },
    { name: "Socomec Countis E23", id: 42 },
    { name: "Socomec Countis E03", id: 43 },
    { name: "UI Toshiba via Passerelle BacNet", id: 44 },
    { name: "UI Mitsubishi via MNet XML", id: 45 },
    { name: "Ventilo Convecteur via automate", id: 46 },
    { name: "Convecteur Fil Pilote", id: 47 },
    { name: "Atlantic Navipass - Navistem B3000", id: 48 },
    { name: "Fludia FM432g_nc_10mn", id: 49 },
    { name: "Hydrelis Switch flow radio", id: 50 },
    { name: "France Air Power Play Max", id: 51 },
    { name: "Viessman Vitocrossal 200", id: 52 },
    { name: "Automate Ventilo Convecteur SAIA", id: 53 },
    { name: "Hydronic AXR", id: 54 },
    { name: "Regulateur VC Distech PTU 208", id: 55 },
    { name: "Belimo energy valve", id: 56 },
    { name: "Ewattch ambiance CO2", id: 57 },
    { name: "Hager 350", id: 58 },
    { name: "Hager 360", id: 59 },
    { name: "Hager 370", id: 60 },
    { name: "Aermec NLC1250", id: 61 },
    { name: "NKE TICSO", id: 62 },
    { name: "Inepro Metering PRO1-Mod", id: 63 },
    { name: "Milesight TS301", id: 64 },
    { name: "MClimate Wireless Thermostat", id: 65 },
    { name: "Systemair E28 Controller", id: 66 },
    { name: "UI Daikin via Intesis Multibrand", id: 67 },
    { name: "Allunits Daikin via Intesis Multibrand", id: 68 },
    { name: "CTA France Air Wallplay 95", id: 69 },
    { name: "BAMO BMG 72", id: 70 },
    { name: "Compteur electrique impulsion", id: 71 },
    { name: "LETTEL MCT1-1100", id: 72 },
    { name: "UI Mitsubishi via Intesis Multibrand", id: 73 },
    { name: "AllGroups Mitsubishi via Intesis Multibrand", id: 73 },
    { name: "Schneider IEM3150", id: 74 },
    { name: "Schneider IEM3250", id: 75 },
    { name: "Schneider IEM3350", id: 76 },
    { name: "PAC HTi-HRC", id: 77 },
    { name: "RF-Track Badgeuse NFC Reader", id: 78 },
    { name: "Controleur de batterie SIREA", id: 79 },
    { name: "CTA SWEGON-GOLD-RX-PX-CX-SD", id: 80 },
    { name: "UI LG via ACSmart5", id: 81 },
    { name: "Inepro Metering PRO380-Mod", id: 82 },
    { name: "Auer Pilote PAC", id: 83 },
    { name: "Intesis INDOOR - Hitachi", id: 84 },
    { name: "Chaufferie via automate WIT", id: 85 },
    { name: "Pompe chaufferie via automate WIT", id: 86 },
    { name: "V3V chaufferie via automate WIT", id: 87 },
    { name: "V2V chaufferie via automate WIT", id: 88 },
    { name: "Pompe à chaleur via automate WIT", id: 89 },
    { name: "Batterie Sirea", id: 90 },
    { name: "PAC Altherma", id: 91 },
    { name: "Chaufferie via automate Siemens", id: 92 },
    { name: "Pompe chaufferie via automate Siemens", id: 93 },
    { name: "V3V chaufferie via automate Siemens", id: 94 },
    { name: "V2V chaufferie via automate Siemens", id: 95 },
    { name: "CTA System Air via automate CAREL", id: 96 },
    { name: "CTA SWEGON-GOLD-04-80-modbus", id: 97 },
    { name: "Rooftop ETT V17", id: 98 },
    { name: "Automate Sauter - VMC", id: 99 },
    { name: "Schneider Electric powerLogic PM5100", id: 100 },
    { name: "LETTEL - MAP6-8RJ", id: 101 },
    { name: "PAC CIAT V13", id: 102 },
    { name: "Pompe à chaleur via automate WIT", id: 103 },
    { name: "Chaudière via automate WIT", id: 104 },
    { name: "Ballon de Stockage via automate WIT", id: 105 },
    { name: "Circuit Radiateurs via automate WIT", id: 106 },
    { name: "Circuit Constant Batterie Terminale via automate WIT", id: 107 },
    { name: "CTA Local Technique Ventilation via automate WIT", id: 108 },
    { name: "VC via automate WIT", id: 109 },
    { name: "Hotte d'extraction via automate WIT", id: 110 },
    { name: "Sonde CO2 Nexelec Sense", id: 111 },
    { name: "CTA Aldes EasyVec C4", id: 112 },
    { name: "Compteur electrique via automate", id: 113 },
    { name: "Compteur energy thermique via automate", id: 114 },
    { name: "CTA via Sofrel S4TH", id: 115 },
    { name: "Circuit Chaufferie via Sofrel S4TH", id: 116 },
    { name: "Chaudiere via Sofrel S4TH", id: 117 },
]

export const controltypeData = [
    { name: "Etat On/Off", id: 1, type: "list", unit: "-" },
    { name: "A/C Mode de fonctionnement", id: 2, type: "list", unit: "-" },
    { name: "Température de consigne", id: 3, type: "int", unit: "°C" },
    { name: "Ouverture de vanne", id: 4, type: "list", unit: "-" },
    { name: "Allumage de pompe", id: 5, type: "list", unit: "-" },
    { name: "Vanne 2V Mode de fonctionnement", id: 6, type: "list", unit: "-" },
    { name: "Vicki Mode de fonctionnement", id: 7, type: "list", unit: "-" },
    { name: "Ouverture manuelle de vanne", id: 8, type: "int", unit: "%" },
    { name: "Limite de température de consigne haute", id: 9, type: "int", unit: "°C" },
    { name: "Limite de température de consigne basse", id: 10, type: "int", unit: "°C" },
    { name: "Limite de température de consigne MClimate WT", id: 11, type: "int", unit: "°C" },
    { name: "CTA Mode de fonctionnement", id: 12, type: "list", unit: "" },
    { name: "Etat sortie 1", id: 13, type: "list", unit: "-" },
    { name: "Etat sortie 2", id: 14, type: "list", unit: "-" },
    { name: "Etat sortie 3", id: 15, type: "list", unit: "-" },
    { name: "Etat sortie 4", id: 16, type: "list", unit: "-" },
    { name: "Charge / décharge batterie", id: 17, type: "int", unit: "W" },
    { name: "Etat du circuit de chauffage", id: 18, type: "list", unit: "-" }
]

export const controllistData = [
    { name: "On", id: "on" },
    { name: "Off", id: "off" },
    { name: "Refroidissement", id: "ac_cold" },
    { name: "Chauffage", id: "ac_heat" },
    { name: "Ventilation", id: "ac_vent" },
    { name: "Auto", id: "ac_auto" },
    { name: "Déshumidification", id: "ac_dehumidification" },
    { name: "Chauffage", id: "v2v_heat" },
    { name: "Refroidissement", id: "v2v_cold" },
    { name: "Manuel", id: "vicki_manual" },
    { name: "Automatique", id: "vicki_auto" },
    { name: "Automatique capteur externe", id: "vicki_autoexternal" },
    { name: "Stop", id: "stop" },
    { name: "Vitesse élevée", id: "highspeed" },
    { name: "Vitesse réduite", id: "lowspeed" },
    { name: "On", id: "on" },
    { name: "Off", id: "off" },
    { name: "On", id: "on" },
    { name: "Off", id: "off" },
    { name: "On", id: "on" },
    { name: "Off", id: "off" },
    { name: "On", id: "on" },
    { name: "Off", id: "off" },
    { name: "Auto", id: "auto" },
    { name: "Confort", id: "confort" },
    { name: "Pré-Confort", id: "preconfort" },
    { name: "Economie", id: "eco" },
    { name: "Protection/Hors gel", id: "protection" },
]


export const updategroupchoiceData = [
    { name: "Equipement uniquement", id: "equipmentonly" },
    { name: "Equipement et point(s) associé(s)", id: "equipmentpoint" },
]